import * as THREE from 'three';
import {
	CARD1Web,
	ThreeExt
} from './CoordUtils.js';
import './thirdparty/loaders/DRACOLoader'
import './thirdparty/loaders/GLTFLoader'
import './thirdparty/Car.js'

export class Plane {
	constructor() {
			this.carParts = {
				body: [],
				rims: [],
				glass: [],
			};
			this.car = new ThreeExt.Car();

		}
		load(onLoaded, onProgress) {
			var _this = this;
			ThreeExt.DRACOLoader.setDecoderPath('/static/bimroad/libs/draco/gltf/');
			var loader = new ThreeExt.GLTFLoader();
			loader.setDRACOLoader(new ThreeExt.DRACOLoader());
			loader.load('/static/bimroad/models/ferrari/ferrari.glb', function(gltf) {
				_this.flyModel = gltf.scene.children[0];
				_this.flyModel.scale.set(0.6, 0.6, 0.6);
				
				_this.flyModel.traverse(function(child) {
					if (child.isMesh) {
						child.castShadow = true;
						child.receiveShadow = true;
					}
				});
				onLoaded.call();
				//updateMaterials();
			}, onProgress);
		}

		setPosition(position){
			this.flyModel.copy(position);
		}

		getPosition(){
			return this.flyModel.position;
		}

		addToScene(scene){
			scene.add(this.flyModel);
		}
		lookAt(position){
			this.flyModel.lookAt(position);
			this.flyModel.rotateY(Math.PI);
		}

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/plane.js